import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/residents/adoption";

export const Route = createFileRoute("/admin/_residents/adoption")({
  component: Page,
});
